import { GOOGLE_RECAPTCHA_SITE_KEY } from '@/constants/env';
import { useSession } from '@/use/session';
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { load } from 'recaptcha-v3';
import { HELP } from '@/constants/icons';
import { useSSO } from '@/use/sso';
import { EMAIL_OR_PHONE_REQ } from '@/constants/authorization';
export default defineComponent({
  setup: (_props, {
    emit
  }) => {
    const forgotPasswordModalRef = ref(null);
    const validPhoneOrEmail = ref(false);
    const emailOrPhone = ref(null);
    const recaptchaToken = ref('');
    const recaptcha = ref();
    const reCAPTCHASiteKey = ref(GOOGLE_RECAPTCHA_SITE_KEY);
    const {
      checkContactExisting
    } = useSession();
    const {
      showLoader
    } = useSSO();
    const inputData = ref({
      inputType: '',
      inputValue: ''
    });
    const phoneOrEmailRef = ref(null);
    const phoneOrEmailErrorMessage = ref('');
    onMounted(async () => {
      recaptcha.value = await load(reCAPTCHASiteKey.value);
    });
    onUnmounted(async () => {
      await recaptcha.value.hideBadge();
    });
    const resetValues = () => {};
    const show = () => {
      forgotPasswordModalRef.value.show();
    };
    const close = () => {
      forgotPasswordModalRef.value.close();
    };
    const checkExists = async () => {
      var _phoneOrEmailRef$valu, _phoneOrEmailRef$valu2;
      showLoader(true);
      if ((_phoneOrEmailRef$valu = phoneOrEmailRef.value) !== null && _phoneOrEmailRef$valu !== void 0 && _phoneOrEmailRef$valu.validate()) {
        recaptchaToken.value = await recaptcha.value.execute('check_contact_details');
        const error = {
          errorText: '',
          isError: false
        };
        inputData.value = {
          inputType: phoneOrEmailRef.value.isPhoneNumber ? 'phone' : 'email',
          inputValue: emailOrPhone.value
        };
        await checkContactExisting(inputData.value.inputValue, recaptchaToken.value, error, inputData.value.inputType);
        phoneOrEmailErrorMessage.value = error.errorText;
      }
      validPhoneOrEmail.value = emailOrPhone.value !== '' && !phoneOrEmailErrorMessage.value && ((_phoneOrEmailRef$valu2 = phoneOrEmailRef.value) === null || _phoneOrEmailRef$valu2 === void 0 ? void 0 : _phoneOrEmailRef$valu2.validate());
      showLoader(false);
    };
    const setOtpAction = () => {
      emit('resend-otp-action', {
        inputType: inputData.value.inputType,
        inputValue: inputData.value.inputValue
      });
    };
    return {
      forgotPasswordModalRef,
      show,
      close,
      checkExists,
      validPhoneOrEmail,
      emailOrPhone,
      resetValues,
      setOtpAction,
      phoneOrEmailRef,
      phoneOrEmailErrorMessage,
      HELP,
      EMAIL_OR_PHONE_REQ
    };
  }
});